export const UFS = ["AC", "AL", "AP", "AM", "BA", "CE", "DF", "ES", "GO", "MA", "MT", "MS", "MG", "PA", "PB", "PR", "PE", "PI", "RJ", "RN", "RS", "RO", "RR", "SC", "SP", "SE", "TO"];

export const digits = (v) => (v || "").replace(/\D/g, "");

export function validCpf(v) {
  const d = digits(v);
  if (d.length !== 11 || /^(\d)\1+$/.test(d)) return false;
  for (const n of [9, 10]) {
    let s = 0;
    for (let i = 0; i < n; i++) s += Number(d[i]) * (n + 1 - i);
    if (((s * 10) % 11) % 10 !== Number(d[n])) return false;
  }
  return true;
}

export function validCnpj(v) {
  const d = digits(v);
  if (d.length !== 14 || /^(\d)\1+$/.test(d)) return false;
  const W = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
  for (const n of [12, 13]) {
    const w = W.slice(13 - n);
    let s = 0;
    for (let i = 0; i < n; i++) s += Number(d[i]) * w[i];
    const r = s % 11;
    if ((r < 2 ? 0 : 11 - r) !== Number(d[n])) return false;
  }
  return true;
}

const mask = (v, pattern) => {
  const d = digits(v);
  let out = "", i = 0;
  for (const ch of pattern) {
    if (i >= d.length) break;
    out += ch === "#" ? d[i++] : ch;
  }
  return out;
};

export const maskCpf = (v) => mask(v, "###.###.###-##");
export const maskCnpj = (v) => mask(v, "##.###.###/####-##");
export const maskCep = (v) => mask(v, "#####-###");
export const maskPhone = (v) => (digits(v).length > 10 ? mask(v, "(##) #####-####") : mask(v, "(##) ####-####"));

export async function lookupCep(cep) {
  const r = await fetch(`https://viacep.com.br/ws/${digits(cep)}/json/`);
  const d = await r.json();
  if (d.erro) throw new Error("CEP não encontrado");
  return { street: d.logradouro || "", district: d.bairro || "", city: d.localidade || "", state: d.uf || "" };
}
